<template>
  <div>
    <validation-observer ref="taskListRules">
      <b-form>
        <b-row>
          <b-col
            sm="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Task List"
              rules="required"
            >
              <b-form-group
                :label="$t('DEBTIA_TASK_LIST')"
                label-for="taskList"
              >
                <v-select
                  v-model="taskListID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="taskListOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="modules"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            cols="12"
          >
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="validationTaskListForm"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BButton,
  BForm,
  BRow,
  BCol,
  // BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import vSelect from 'vue-select'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    // BInputGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      taskListID: '',
      taskListOptions: [],
    }
  },
  created() {
    this.getTaskList()
  },
  methods: {
    async getTaskList() {
      const args = []
      this.taskListOptions = []
      const data = await axios.get('/task-list/get-task-list?perPage=100000')
      if (data.status === 200) {
        // this.modalLoader = false
        // console.log('data-->', data.data.data.data)
        data.data.data.data.forEach(element => {
          args.push({ label: element.title, value: element.id })
        })

        this.taskListOptions.push(...args)
        // console.log('this.taskListOptions ', this.taskListOptions)
      }
    },
    async validationTaskListForm() {
      // console.log('in await creation this.conditionObject.parentID, ', this.conditionObject.parentID)
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 10,
        module_order: 1,
        task_list_id: Number(this.taskListID),
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      await this.$refs.taskListRules.validate().then(success => {
        if (success) {
          const url = '/process/module/add'
          axios.post(url, dataObj).then(response => {
            if (response.status === 200) {
              this.reminderFee = 0
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeTaskListModal', returnObj)
            }
          }).catch(e => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: e.response.data.message[0],
              },
            })
          })
          /* console.log(this.validateFee)
          if (!this.validateFee) {
            console.log('fee not validated')
            return
          } */
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }
</style>
